import { Injectable, inject } from '@angular/core';

import { ToastController } from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root'
})
export class HelperToastControllerService {
  private toastController = inject(ToastController);

  async presentToast(
    message: string,
    color: 'success' | 'danger' | 'warning' | 'info' | 'primary' = 'primary',
    duration: number = 3000,
    position: 'top' | 'bottom' | 'middle' = 'bottom'
  ): Promise<void> {
    const toast = await this.toastController.create({
      message,
      color,
      duration,
      position,
      buttons: [
        {
          text: 'Dismiss',
          role: 'cancel'
        }
      ]
    });
    await toast.present();
  }

  async presentError(message: string, duration = 4000): Promise<void> {
    return this.presentToast(message, 'danger', duration);
  }
}
